export default {
    directoriesStandardToDisplay: [],
    directoriesToVisaToDisplay: [],
    directoriesLocalToDisplay: [],
    currentPath: "",
    limitParentPath: 1,
    selectedKeyDirectory: "",
    selectedDirectory: "",
};